// extracted by mini-css-extract-plugin
module.exports =  {"chartIcon":"chartIcon_RlQXNv64","small":"small_yqdQBYHA","medium":"medium_mjvfsEpg","chartIconSelected":"chartIconSelected_UYsrG9ie"};